"use client";
import { useEffect, useRef } from "react";

// Lightweight scroll progress — replaces framer-motion useScroll + useSpring
// which was running a spring animation on every scroll frame (every 16ms),
// keeping the main thread busy and preventing input focus from being processed.
export function ScrollProgress() {
  const barRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const bar = barRef.current;
    if (!bar) return;

    let rafId = 0;

    const update = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const progress = docHeight > 0 ? scrollTop / docHeight : 0;
      // Direct DOM mutation — no React re-render, no spring animation overhead
      bar.style.transform = `scaleX(${progress})`;
    };

    const onScroll = () => {
      cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(update);
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    update(); // initial

    return () => {
      window.removeEventListener("scroll", onScroll);
      cancelAnimationFrame(rafId);
    };
  }, []);

  return (
    <div
      ref={barRef}
      aria-hidden
      style={{ transform: "scaleX(0)", transformOrigin: "left" }}
      className="fixed left-0 top-0 z-[100] h-[2px] w-full bg-gradient-to-r from-gold via-gold to-gold/40 will-change-transform"
    />
  );
}